let lazyLoad = {
    $lazy: $('.js-lazy'),
    classNameLazyLoaded: 'is-loaded',
    offset: '125%',

    init() {
        console.log('lazyLoad.init')

        this.$lazy.waypoint(function (direction) {
            let $el
            let classNameLazyLoaded
            let src

            $el = $(this.element)
            classNameLazyLoaded = this.classNameLazyLoaded

            if (window.devicePixelRatio >= 1.5 && $(window).width() >= 480) {
                src = $el.attr('data-src-hd') || $el.attr('data-src')
            } else {
                src = $el.attr('data-src')
            }

            if (src !== undefined) {
                img = new Image()
                img.onload = (e) => {
                    if ($el.get(0).tagName.toLowerCase() === 'img') {
                        $el.attr('src', src)
                    } else {
                        $el.css('background-image', `url('${src}')`)
                    }

                    $(e.target).remove()
                    $el.removeAttr('data-src data-src-hd')
                    $el.addClass(classNameLazyLoaded)
                }
                img.src = this.photo.src
            }

            this.destroy()
        }, {
            offset: this.offset
        })
    }
}

export default lazyLoad